import { Typography } from "@material-ui/core";
import dayjs from "dayjs";
import { FC } from "react";

import { TimeStampClass } from "../types/firebase.types";

const TimestampField: FC<any> = ({ record, source, cellClassName }) => {
  return record[source] && record[source] instanceof TimeStampClass ? (
    <Typography variant="body2" className={cellClassName}>
      {dayjs(record[source].toDate()).format("DD/MM/YYYY - hh:mm a")}
    </Typography>
  ) : null;
};

export default TimestampField;
